<template>
  <div>
    <div style="padding:2px 5px">
      <van-search
        v-model="k"
        placeholder="请输入关键词，例如：小区、位置"
        show-action
        shape="round"
        @search="onSearch"
      >
        <div slot="label" @click="show=true">{{txt}}</div>
        <div slot="left-icon">
          <van-icon name="arrow-down" size="12" />
        </div>
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
    </div>
    <div class="blank"></div>
    <div style="padding:15px 0 0 15px">搜索结果</div>
    <div class="houselist">
      <ul>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          :immediate-check="true"
        >
          <li v-for="(item,index) in lists" :key="index" @click="goto(item.id)">
            <div class="img">
              <div class="top" v-if="item.stick"></div>

              <img :src="item.thumbnail" />
            </div>
            <div class="info">
              <h1>{{item.title}} {{item.price ? item.price+item.unit:'面议'}}</h1>

              <div class="pflex">
                <p class="txt2">{{item.shi}}{{item.ting}} | {{item.community}}</p>
                <p class="txt1">
                  {{item.price ? item.price:'面议'}}
                  <small v-if="item.price">{{item.unit}}</small>
                </p>
              </div>
            </div>
          </li>
        </van-list>
      </ul>
    </div>
    <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    <footbar />
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;

import Footbar from "./commpents/footbar";

import {
  Toast,
  DropdownMenu,
  DropdownItem,
  TreeSelect,
  Tag,
  List,
  Icon,
  Button,
  Dialog,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  ActionSheet
} from "vant";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    [List.name]: List,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Dialog.name]: Dialog,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Row.name]: Row,
    [Col.name]: Col,
    [Search.name]: Search,
    [ActionSheet.name]: ActionSheet,
    Footbar
  },

  data() {
    return {
      getInitUrl: root + "search",
      value: 0,
      type: "",
      page: 1,
      lists: [],
      total: 0,
      show: false,
      loading: false,
      finished: false,
      active: 0,
      k: "",
      txt: "选择",
      actions: [
        { name: "租房", key: "zufang" },
        { name: "二手房", key: "ershoufang" },
        { name: "商铺", key: "shop" }
      ]
    };
  },

  mounted() {},

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: { page: self.page, type: self.type, k: self.k },
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          if (reponseData.status == 0) {
            self.$toast(reponseData.message);
            self.finished = true;
            self.loading = false;
            return;
          }
          var lists = reponseData.data.lists;
          if (lists.length == 0) {
            self.finished = true;
          }
          self.loading = false;
          self.total = reponseData.data.total;
          for (var i in lists) {
            self.lists.push(lists[i]);
          }
          self.page++;
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },

    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        if (this.page >= this.total) {
          this.finished = true;
          this.loading = false;
          return;
        }
        this.loading = true;
        this.init();
      }, 500);
    },
    onSearch() {
      this.page = 1;
      this.lists = [];
      this.loading = true;
      this.finished = false;
      this.init();
    },
    onSelect(item) {
      console.log(item);
      this.txt = item.name;
      this.type = item.key;
      this.show = false;
    },
    goto(id) {
      if (this.type == "zufang") {
        this.$router.push("/zufang/view/" + id);
      }
      if (this.type == "ershoufang") {
        this.$router.push("/ershoufang/view/" + id);
      }
      if (this.type == "shop") {
        this.$router.push("/shop/view/" + id);
      }
    }
  }
};
</script>

<style scoped>
.user {
  background-color: #3072f6;
  display: flex;
  padding: 30px 25px;
  color: #fff;
}
.avatar-img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-img img {
  width: 80%;
}
.avatar-info {
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-info h1 {
  font-size: 18px;
}
.avatar-info p {
  font-size: 14px;
  color: #fff;
  padding: 4px 0;
}
.user-tag {
  text-align: center;
  padding: 15px 0;
}
.user-tag img {
  width: 40px;
}
.user-tag h1 {
  margin-top: 6px;
  font-size: 14px;
  font-weight: normal;
  color: #555;
}
.user-logout {
  text-align: center;
  padding: 15px;
  margin: 15px;
  background-color: #f8f8f8;
  border-radius: 4px;
}
</style>>



